export default '/build/f225529d.png'